
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Column, ColumnType, } from '../../../../SGRE-shared/models/tableConfiguration';
import { selectUserLegalEntities } from '../../../../SGRE-shared/store/shared-store/selectors/shared.selector';
import { MapLegalEntityData, UsersTableData, UserTableColumn, UserTableColumnHeader } from '../../model/user-page-model';
import { UserStateInitial } from '../user-data.state';

@Injectable({
  providedIn: 'root',
})

export class UserEffectService {
  public defaultlegalentities;

  constructor(private store: Store) { }

  formatUsersData(data: UsersTableData[]): UserStateInitial {
    const modifiedData = data.map((item) => {
      const legalEntites: string[] = [];
      item?.legalEntityList?.map((item?: string | number) => {
        legalEntites.push(this.findLegalEntityName(item));
      });
      item.legalEntityNames = legalEntites;
      return item;
    });
    const modifiedUserData = this.usersTableConfiguration(modifiedData);
    return modifiedUserData;
  }

  findLegalEntityName(uid?: string | number): string {
    let legalEntitiesData;
    this.store
      .pipe(select(selectUserLegalEntities))
      .subscribe((legalEntities) => {
        legalEntitiesData = legalEntities ? legalEntities : [];
      });
    return legalEntitiesData?.find((item) => item.uid === uid)?.name;
  }

  usersTableConfiguration(userdata): UserStateInitial {
    const displayFilter = this.getFilterData(userdata, UserTableColumn.DISPLAY_NAME);
    const emailFilter = this.getFilterData(userdata, UserTableColumn.EMAIL);
    const alternativeEmailFilter = this.getFilterData(userdata, UserTableColumn.ALTERNATIVE_EMAIL);
    const companyFilter = this.getFilterData(userdata, UserTableColumn.COMPANY);
    this.store
      .pipe(select(selectUserLegalEntities))
      .subscribe((legalEntities) => {
        this.defaultlegalentities = legalEntities ? legalEntities : [];
        return this.defaultlegalentities;
      });
    const updatelegaldata = this.defaultlegalentities.map((item) => {
      const maplegalEntityData: MapLegalEntityData = {};
      maplegalEntityData.uid = item.uid;
      maplegalEntityData.legalEntityCount = item.name;
      return maplegalEntityData;
    });
    const columnData = [
      {
        label: UserTableColumnHeader.NAME,
        name: UserTableColumn.DISPLAY_NAME,
        type: ColumnType.link,
        filter: true,
        filterOptions: displayFilter,
      },
      {
        label: UserTableColumnHeader.USER_NAME,
        name: UserTableColumn.EMAIL,
        type: ColumnType.link,
        filter: true,
        filterOptions: emailFilter,
      },
      {
        label: UserTableColumnHeader.ALTERNATIVE_EMAIL,
        name: UserTableColumn.ALTERNATIVE_EMAIL,
        type: ColumnType.text,
        filter: true,
        filterOptions: alternativeEmailFilter,
      },
      {
        label: UserTableColumnHeader.COMPANY,
        name: UserTableColumn.COMPANY,
        type: ColumnType.text,
        filter: true,
        filterOptions: companyFilter,
      },
      {
        label: UserTableColumnHeader.LEGAL_ENTITIES,
        name: UserTableColumn.LEGAL_ENTITY_COUNT,
        type: ColumnType.text,
        filter: true,
        filterOptions: updatelegaldata,
      },
    ];
    const columns = columnData.map((item) => new Column(item));
    return { userstableData: userdata, columns };
  }

  getFilterData(modifiedFilterData: [], filterKey: string): Record<string, string>[] {
    const filteredArray = modifiedFilterData
      ?.filter((item) => item[filterKey] !== undefined)
      .map((item) => ({ [filterKey]: item[filterKey] }));
    const uniqueArray = Array.from(
      new Set(filteredArray.map(item => JSON.stringify(item)))
    ).map(item => JSON.parse(item));
    return uniqueArray;
  }

}
